import { AxiosRequest } from "../../../Url";
import { getRightsData } from "../../Tools/Tools";
import { CreateCollapsibleRecords } from "../GridTools/collapsibleRecordsTools";
import { createGrid, createRecordSource } from "../rcsgrid";
import { getscheduleColumns } from "./Columns/scheduleColumns";
import smetaAxios from "../../../SmetaAxios";

export async function scheduleGrid(grid: createGrid, source: createRecordSource, props, data) {
  source.onHandleRequest = handleRequest(props);
  //создание стилей для сворачивающихся записей
  source.CreateCollapsibleRecords = CreateCollapsibleRecords;

  await source.open();

  source.rights = getRightsData("-1");
  //   const keyFieldName = source.getKeyFieldName();
  //   if (!keyFieldName) source.setKeyFieldName("CODE");

  const codeField = source.fields[source.getFieldIndex("Code")];
  //создание дефолтных полей()
  const columns = getscheduleColumns(codeField);
  grid.setColumns(columns);

  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = async function (source: createRecordSource) {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };
  }

  await grid.setSource(source);

  source.onRecordCollapsed = async function (event) {
    const recordIndex = event.currentTarget !== undefined ? event.currentTarget.getAttribute("recordindex") : event;
    await smetaAxios.get("RecordCollapsed", {
      prefix: props.Module,
      params: { SectionID: props.SectionID, ObjType: props.ObjType, RecordIndex: recordIndex },
      loadMask: true,
    });
    await grid.refreshSource("!");
    if (data.setCountRecords) data.setCountRecords(source.recordCount);
    return;
  };

  await grid.refreshSource();

  await grid.updateGridSize();

  if (data.setSelectedRecord) {
    data.setSelectedRecord(source.getFieldTextSync("ID"));
  }
}

function handleRequest(props) {
  return (request, loadCursor, wsm, subParams) => {
    const params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "HandleTable")
      .set("ObjType", props.ObjType)
      .set("SectionID", props.SectionID)
      .set("GroupID", props.GroupID || "0");
    if (wsm) params.set("WSM", "1");
    if (subParams) {
      const sParams = Object.entries(subParams);
      sParams.forEach(([key, value]) => {
        params.set(key, value);
      });
    }
    return AxiosRequest(loadCursor !== undefined ? loadCursor : true, params, request);
  };
}
